const _isLoggedIn = Boolean(document.cookie.match(/(^| )regbase_id=([^;]+)/g));

const isLoggedIn = () => _isLoggedIn;

export default isLoggedIn;